export const toKebabCase = (str: string) => {
  return str
    .trim()
    .toLowerCase()
    .normalize('NFD') // Decompose accented characters
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics/accents
    .replace(/[^a-z0-9\s-]/g, '') // Remove other special characters
    .replace(/[\s-]+/g, '-') // Convert spaces to hyphens
}
